import MarkFileUploaded from './MarkFileUploaded';

export default MarkFileUploaded;
